import {Avatar, styled} from '@material-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';

interface ImageButtonProps {
  imageUrl: string;
  accountId: number;
  handlePostProfileClick: (accountId: number) => void
}

const ProfileIcon: React.FC<ImageButtonProps> = ({ imageUrl, accountId, handlePostProfileClick }) => {
  return (
    <CustomAvatar
      data-test-id="preview-post-profile-wrapper"
      onClick={(event) => { event.stopPropagation(); handlePostProfileClick(accountId) }}
    >
      <Link to={`/profile/${accountId}`}>
        <img
          src={imageUrl}
          className="fallbackAvatar"
        />
      </Link>
    </CustomAvatar>
  );
};

const CustomAvatar = styled(Avatar)(({theme}) => ({
  width: "32px",
  height: "32px",
  backgroundColor: "#FFF",
  border: "2px solid #F0E5FF",
  marginBottom: "4px",
  [theme.breakpoints.down(950)]: { 
    width: "32px",
    height: "32px",
    "& img": {
      height: "32px",
      width: "32px"
    }
  },
  "& .fallbackAvatar": {
      width: "32px",
      height: "32px",
      objectFit: "cover",
    }, 
}))

export default ProfileIcon;
